import React from "react";
import { useNavigate } from "react-router-dom";
import "./areas.css";
import { areasData } from "./data/areasData";

const Areas = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid areas-container mt-5">
   <h2 className="expertise-title">Areas we serve</h2>
      <p className="subtitle text-center">
        Reliable laundry & dry cleaning services available across Dubai and Abu Dhabi
      </p>

      <div className="row">
        {/* LEFT SPACE */}
        <div className="col-sm-1"></div>

        {/* CENTER CONTENT */}
        <div className="col-sm-10">
          {/* DUBAI */}
          <h2 className="expertise-title">Dubai</h2>
         
     <div className="grid py-5 area-grid">
  {areasData.Dubai.map((area) => (
    <div
      key={area}
      className="area-item"
      onClick={() => navigate(`/area/${area}`)}
    >
      <span className="check-icon">✔</span>
      <p>{area}</p>
    </div>
  ))}
</div>

          {/* ABU DHABI */}
          <h3 className="expertise-title mb-5">Abu Dhabi</h3>
          <div className="grid mb-5">
            {areasData["Abu Dhabi"].map((area) => (
              <div
                key={area}
                className="area-item"
                onClick={() => navigate(`/area/${area}`)}
              >
                ✔ {area}
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SPACE */}
        <div className="col-sm-1"></div>
      </div>
    </div>
  );
};

export default Areas;
